import { render } from "./TaskDetails.vue?vue&type=template&id=63b881c8&ts=true"
import script from "./TaskDetails.vue?vue&type=script&lang=ts"
export * from "./TaskDetails.vue?vue&type=script&lang=ts"

import "./TaskDetails.vue?vue&type=style&index=0&id=63b881c8&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__